import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TopHeaderFiltersComponent } from './top-header-filters/top-header-filters.component';

@Component({
  selector: 'z-top-header-right-section',
  standalone: true,
  imports: [CommonModule, TopHeaderFiltersComponent],
  templateUrl: './top-header-right-section.component.html',
})
export class TopHeaderRightSectionComponent {}
